import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  EnquiryData: null,
  EnquiryNo: "",
  LotNo: "",
};

const EnquirySlice = createSlice({
  name: "Enquiry",
  initialState,
  reducers: {
    setEnquiryData(state, action) {
      state.EnquiryData = action.payload;
    },
    setEnquiryMeta(state, action) {
      state.EnquiryNo = action.payload?.EnquiryNo || "";
      state.LotNo = action.payload?.LotNo || "";
    },
    clearEnquiryData(state) {
      state.EnquiryData = null;
      state.EnquiryNo = "";
      state.LotNo = "";
    },
  },
});

export const { setEnquiryData, setEnquiryMeta, clearEnquiryData } =
  EnquirySlice.actions;
export default EnquirySlice.reducer;
